module.exports = __webpack_public_path__ + "media/images/icons/flags/TK-03455b5ff8b76d142a53e9ee73d34541.svg";